import { createFileRoute } from '@tanstack/react-router';

import { UdzialView } from '../../raporty/projekty/UdzialView';

export const Route = createFileRoute('/raporty/udzial-w-wyniku')({
  component: UdzialView,
});
